






















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import ListenersTableItem from "@/components/tables/ListenersTableItem.vue";
import { EducationProtocol as IEducationProtocol } from "@/api/models";
import { mapGetters } from "vuex";
import { uniqBy } from "lodash";

@Component({
  computed: {
    ...mapGetters({
      SELECTED_LISTENERS: "SELECTED_LISTENERS",
      LISTENERS: "LISTENERS"
    })
  },
  components: { ListenersTableItem }
})
export default class ListenerTable extends Vue {
  @Prop() allListeners!: Array<ICourseListener>;
  @Prop({ default: () => [] }) checkedListeners!: Array<ICourseListener>;
  @Prop({ default: true }) activeCheckbox!: boolean;
  @Prop({ default: false }) showFinalDoc!: boolean;
  @Prop() protocol!: IEducationProtocol;
  sortVariable: string = "";
  checkBoxForSelectAll: boolean = false;

  get screenWidth() {
    return window.innerWidth;
  }
  @Watch("allListeners")
  checkAllListeners() {
    this.checkCheckedListener();
  }

  @Watch("SELECTED_LISTENERS")
  checkCheckedListener() {
    this.checkBoxForSelectAll =
      this.allListeners.length ===
      this.$store.getters.SELECTED_LISTENERS.length;
    this.$emit("getCheckedListeners", this.$store.getters.SELECTED_LISTENERS);
  }

  checkActive(item: ICourseListener) {
    return !!this.checkedListeners?.includes(item);
  }

  sortListeners(sortItem: string) {
    this.sortVariable = sortItem;
    if (sortItem === this.$tc(this.$translate.Test)) {
      this.allListeners.sort((x, y) => {
        return x.testCompleted === y.testCompleted
          ? 0
          : x.testCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === this.$tc(this.$translate.Practice)) {
      this.allListeners.sort((x, y) => {
        return x.practiceCompleted === y.practiceCompleted
          ? 0
          : x.practiceCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === this.$tc(this.$translate.Training)) {
      this.allListeners.sort((x, y) => {
        return x.status === y.status ? 0 : x.status === "success" ? -1 : 1;
      });
    }
  }
  beforeDestroy() {
    this.$store.dispatch("CLEAR_LISTENER_TABLE_STATE");
  }

  mounted() {
    this.$store.dispatch("CLEAR_LISTENER_TABLE_STATE");
    this.$store.dispatch(
      "SETUP_LISTENERS",
      uniqBy([...this.checkedListeners, ...this.allListeners], "id")
    );
    if (this.checkedListeners)
      this.$store.dispatch("SETUP_SELECTED_LISTENERS", this.checkedListeners);

    this.checkCheckedListener();
  }
}
